module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Regular.aac99e6.ttf";